<template>
  <div class="choice-item container-fluid">
    <div class="row">
      <div class="col-xs-9">
        <span class="choice-title">
          <span v-show="!isEditing || !isEditable">{{ choice.title }}</span>
          <span v-show="isEditing && isEditable">
            <el-input
              class="choice-editor"
              ref="choiceInput"
              size="mini"
              :autofocus="true"
              :focus="true"
              v-model="editTitle"
              @keyup.native.enter="handleUpdateChoice"
              @blur="handleInputBlur"
            ></el-input>
          </span>
        </span>
      </div>
      <div class="col-xs-3" v-if="isEditable">
        <span class="choice-tools pull-right">
          <el-tooltip content="Edit">
            <i class="fa fa-fw fa-pencil" @click="handleEdit"></i>
          </el-tooltip>
          <el-tooltip content="Remove">
            <i class="fa fa-fw fa-trash" @click="handleRemove"></i>
          </el-tooltip>
          <span class="tool-divider"></span>
          <span class="handle">
            <i class="fa fa-fw fa-navicon"></i>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ConditionalLinkSelect from '@/components/surveybuilder/editors/ConditionalLinkSelect';

export default {
  name: 'SelectChoiceItem',
  components: {
    ConditionalLinkSelect,
  },
  props: {
    choice: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isEditing: false,
    editTitle: null,
    conditionalLink: null,
  }),
  mounted() {
    this.editTitle = this.choice.title;
    this.isEditing = this.choice.title === '';
  },

  methods: {
    handleEdit() {
      this.isEditing = !this.isEditing;

      if (this.isEditing) {
        this.$refs.choiceInput.focus();
      } else {
        this.handleUpdateChoice();
      }
    },

    handleRemove() {
      this.$emit('onRemove', this.choice);
    },

    handleUpdateChoice() {
      if (this.editTitle === '') {
        this.handleRevertUpdate();
      } else {
        this.$emit('onUpdateChoice', {
          ...this.choice,
          title: this.editTitle,
          conditionalLink: this.conditionalLink,
        });
        this.isEditing = false;
      }
    },

    handleRevertUpdate() {
      this.editTitle = this.choice.title;
      this.isEditing = false;
    },

    handleInputBlur() {
      if (isNaN(this.choice.id) && this.editTitle === '') {
        this.$emit('onEmpty');
      } else {
        this.handleUpdateChoice();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/_variables_live.scss';

.choice-item {
  width: 100%;
  margin-bottom: 4px;
  padding: 8px;
  border-radius: 3px;
  background-color: $colony-light-gray;
  border-color: darken($colony-light-gray, 15%);
}

.choice-editor {
  margin: -5px;
}

.choice-tools {
  cursor: pointer;
  color: darken($colony-light-gray, 15%);
  white-space: nowrap;
}

.tool-divider {
  display: inline-block;
  width: 1px;
  height: 1em;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
  background-color: darken($colony-light-gray, 15%);
}

.choice-polarity {
  position: absolute;
  margin-top: -9px;
  font-size: 10px;
  font-family: monospace;
}

.handle {
  cursor: grab;
}
</style>



// WEBPACK FOOTER //
// SelectChoiceItem.vue?ab342624